import { Form, Input } from "antd"
import { AccountModel, LoginModel } from "../../../../model/searchInvoiceModels";
import useAxios from "../../../../helper/axios";
import localStorageManagement from "../../../../helper/services/localStorageServices";
type SubmitCallBack = (token: string) => void
const useLoginForm = (submitCallBack: SubmitCallBack) => {
    const axios = useAxios();
    const [formRef] = Form.useForm();
    const UI: React.FC = () => (<Form
        name="searchByAccountForm"
        initialValues={{ remember: true }}
        autoComplete="off"
        className=""
        form={formRef}
        onFinish={(values) => {
            const account: LoginModel = {
                ...values
            }
            axios.post("Account/Login", account)
                .then((response) => {
                    if (!response) return;
                    let account: AccountModel = {
                        ...response.data?.data
                    }
                    localStorageManagement.setUser(account);
                    submitCallBack(response?.data?.data?.token);
                })
        }}
    >
        <Form.Item
            label="Mã số thuế"
            name="mst"
            rules={[
                { required: true, message: "Vui lòng nhập mã số thuế" },
                { pattern: RegExp("([a-zA-Z0-9]{10}[-][a-zA-Z0-9]{3})|([a-zA-Z0-9]{10})"), message: "Mã số thuế không hợp lệ" }
            ]}
            className="form-label-message"
        >
            <Input />
        </Form.Item>
        <Form.Item
            label="Tài khoản"
            name="username"
            rules={[
                { required: true, message: "Vui lòng nhập tài khoản tra cứu" },
            ]}
            className="form-label-message"
        >
            <Input />
        </Form.Item>
        <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
            className="form-label-message"
        >
            <Input type="password" />
        </Form.Item>
        {/* <Form.Item>
            <Button type="primary" htmlType="submit">
                Đăng nhập
            </Button>
        </Form.Item> */}
    </Form>
    )
    return { UI, formRef }
}
export default useLoginForm;